import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { convertStraight } from "../../common-data/Converts";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { getMetricId } from "../PayroleMocks";

const ResolveForm = ({
  userInfoData,
  resolveFormRef,
  selectedRows,
  allRows = [],
  callFunction,
  closeModal,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const initialFormValues = {
    resolutionNote: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [actionType, setActionType] = useState("");

  const selectedUids = selectedRows.map((row) => row.uid);

  const unselectedRows = allRows.filter(
    (row) => !selectedUids.includes(row.uid)
  );

  const getSelectedStatus = (a = actionType) => {
    return a === "resolved" ? "approved" : "rejected";
  };

  const getUnselectedStatus = (a = actionType) => {
    return a === "resolved" ? "rejected" : "approved";
  };

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.resolutionNote.trim()) {
      errors.resolutionNote = "Resolution note is required!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = "/payrole/discrepancy";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e, action) => {
    e.preventDefault();
    setActionType(action);

    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      // const selectedStatus = getSelectedStatus();
      // const unselectedStatus = getUnselectedStatus();
      const isResolved = action === "resolved";
      const selectedStatus = isResolved ? "approved" : "rejected";
      const unselectedStatus = isResolved ? "rejected" : "approved";

      const allDiscrepancies = [
        ...selectedRows.map((row) => ({
          uid: row.uid,
          status: selectedStatus,
        })),
        ...unselectedRows.map((row) => ({
          uid: row.uid,
          status: unselectedStatus,
        })),
      ];

      const payload = {
        payrole_id: rowData?.payrole_id || "",
        user_id: selectedRows[0]?.user_id || "",
        resolution_note: formValues.resolutionNote || "",
        discrepancies: allDiscrepancies,
      };

      console.log(payload);

      const handleConfirm = async () => {
        handleSubmitForm(payload);
      };

      const actionText = action === "resolved" ? "approve" : "reject";
      const oppositeText = action === "resolved" ? "reject" : "approve";

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to ${actionText} ${selectedRows.length} selected discrepancy/discrepancies and ${oppositeText} ${unselectedRows.length} unselected discrepancy/discrepancies?`,
        "No, Cancel",
        "Yes, Submit"
      );
    }
  };

  return (
    <div ref={resolveFormRef} className="resolve-discrepancy-container">
      <div className="resolve-discrepancy-header">
        <h3 className="resolve-discrepancy-title">Resolve Discrepancy</h3>
      </div>

      <div className="resolve-discrepancy-content">
        <div className="pp-resolution-employee-info">
          {/* <h4>{rowData?.user_name || selectedRows[0]?.user_name || "N/A"}</h4> */}

          {selectedRows.length > 0 && (
            <div className="selected-rows-section">
              <h5 className="section-title">
                <span className="selected-indicator">✓</span>
                Selected Discrepancies ({selectedRows.length})
                {actionType && (
                  <>
                    {" "}
                    - Will be marked as{" "}
                    <span className={`status-badge ${getSelectedStatus()}`}>
                      {getSelectedStatus()}
                    </span>
                  </>
                )}
              </h5>
              <ul className="discrepancy-list selected-list">
                {selectedRows.map((row, index) => (
                  <li
                    key={row.uid || index}
                    className="discrepancy-item selected-item"
                  >
                    <div className="discrepancy-date">
                      {row.date ? convertStraight(row.date) : "N/A"}
                    </div>
                    <div
                      className={`discrepancy-type pp-employee-payroll-badge ${getMetricId(
                        row?.type
                      )}`}
                    >
                      {row?.type?.replace(/_/g, " ") || "N/A"}
                    </div>
                    <div className="discrepancy-description">
                      {row.description || "N/A"}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {unselectedRows.length > 0 && (
            <div className="unselected-rows-section">
              <h5 className="section-title">
                <span className="unselected-indicator red">✗</span>
                Unselected Discrepancies ({unselectedRows.length})
                {actionType && (
                  <>
                    {" "}
                    - Will be marked as{" "}
                    <span className={`status-badge ${getUnselectedStatus()}`}>
                      {getUnselectedStatus()}
                    </span>
                  </>
                )}
              </h5>
              <ul className="discrepancy-list unselected-list">
                {unselectedRows.map((row, index) => (
                  <li
                    key={row.uid || index}
                    className="discrepancy-item unselected-item"
                  >
                    <div className="discrepancy-date">
                      {row.date ? convertStraight(row.date) : "N/A"}
                    </div>
                    <div
                      className={`discrepancy-type pp-employee-payroll-badge ${getMetricId(
                        row?.type
                      )}`}
                    >
                      {row?.type?.replace(/_/g, " ") || "N/A"}
                    </div>
                    <div className="discrepancy-description">
                      {row.description || "N/A"}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {actionType && (
            <div className="status-preview">
              <h5 className="preview-title">Action Preview:</h5>
              <div className="preview-content">
                <div className="preview-item">
                  <span className="preview-label">Selected rows:</span>
                  <span className={`preview-status ${getSelectedStatus()}`}>
                    {getSelectedStatus().toUpperCase()}
                  </span>
                </div>
                <div className="preview-item">
                  <span className="preview-label">Unselected rows:</span>
                  <span className={`preview-status ${getUnselectedStatus()}`}>
                    {getUnselectedStatus().toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="resolution-note-section">
          <label className="resolution-note-label">
            Resolution Note <span style={{ color: "#dc2626" }}>*</span>
          </label>

          <div className="action-instructions">
            <p className="instruction-text">
              <strong>Instructions:</strong> Click "Mark Resolved" to approve
              selected discrepancies and reject unselected ones, or click
              "Reject" to reject selected discrepancies and approve unselected
              ones.
            </p>
          </div>

          <textarea
            className={`resolution-textarea ${
              formErrors.resolutionNote ? "error" : ""
            }`}
            placeholder="Explain how these discrepancies were resolved..."
            name="resolutionNote"
            value={formValues.resolutionNote}
            onChange={onChangeInput}
            disabled={postPutLoading}
          />
          {formErrors.resolutionNote && (
            <span className="error-message">{formErrors.resolutionNote}</span>
          )}
        </div>

        <div className="resolution-actions">
          <button
            className="resolution-button resolution-button-resolved"
            onClick={(e) => onSubmit(e, "resolved")}
            disabled={postPutLoading || !formValues.resolutionNote.trim()}
          >
            <svg
              className="resolution-button-icon"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
            {postPutLoading ? "Processing..." : "Mark Resolved"}
          </button>

          <button
            className="resolution-button resolution-button-rejected"
            onClick={(e) => onSubmit(e, "rejected")}
            disabled={postPutLoading || !formValues.resolutionNote.trim()}
          >
            <svg
              className="resolution-button-icon"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {postPutLoading ? "Processing..." : "Reject"}
          </button>

          <button
            className="resolution-button resolution-button-cancel"
            onClick={closeModal}
            disabled={postPutLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResolveForm;
